const initState = {
    gestionPaquetes_Data: null,
    gestionPaquetes_Error: null,
    gestionPaquetes_Excel:null,
    gestionPaquetes_Excel_Error:null,
    loading: null
}

const gestionPaquetesReducer = (state = initState, action) => {
    switch (action.type) {
        case "GESTION_PAQUETES_SUCCESS":
            return {
                ...state,
                gestionPaquetes_Data:action.payload.data,
                gestionPaquetes_Error:null
            }
        case "GESTION_PAQUETES_ERROR":
            return {
                ...state,
                gestionPaquetes_Data:null,
                gestionPaquetes_Error:action.payload.error
            }
        case "GESTION_PAQUETES_EXCEL":
            // payload.data = {nombreexcel, fileToken}
            return {
                ...state,
                gestionPaquetes_Excel:action.payload.data,
                gestionPaquetes_Excel_Error:null
            }
        case "GESTION_PAQUETES_EXCEL_ERROR":
            // NO toca gestionPaquetes_Data: un fallo del Excel no debe vaciar el resumen
            return {
                ...state,
                gestionPaquetes_Excel:null,
                gestionPaquetes_Excel_Error:action.payload.error
            }
        case "GESTION_PAQUETES_EXCEL_LIMPIAR":
            return{
                ...state,
                gestionPaquetes_Excel:null,
                gestionPaquetes_Excel_Error:null,
            }
        case "GESTION_PAQUETES_LIMPIAR_DATA":
            return{
                ...state,
                gestionPaquetes_Data:null,
            }
        default:
            return state;
    }
};


export default gestionPaquetesReducer;